import styles from './ImageCropper.styles.m.css';
import { TImageCropperType } from './ImageCropper.types';

export const createPreCroppedImage = (image: string): HTMLImageElement => {
  const preCroppedImage = new Image();

  preCroppedImage.setAttribute('src', image);

  return preCroppedImage;
};

export const getCropAreaClassName = (type: TImageCropperType): string => {
  switch (type) {
    case 'square':
      return styles.cropAreaSquare;
    case 'cover':
      return styles.cropAreaCover;
    case 'round':
    default:
      return styles.cropAreaRound;
  }
};

export const getCropperObjectFit = (type: TImageCropperType): 'contain' | 'vertical-cover' => {
  return type === 'cover' ? 'vertical-cover' : 'contain';
};
